import { LocalizationKeys, type PartialTranslations } from '../../keys'

/**
 * Переводы регионов на русский язык
 */
export const ruRegionTranslations: PartialTranslations = {
  [LocalizationKeys.REGION_UNSPECIFIED]: 'Не указан',
  
  // Europe
  [LocalizationKeys.REGION_RUSSIA]: 'Россия',
  [LocalizationKeys.REGION_UNITED_KINGDOM]: 'Великобритания',
  [LocalizationKeys.REGION_GERMANY]: 'Германия',
  [LocalizationKeys.REGION_FRANCE]: 'Франция',
  [LocalizationKeys.REGION_ITALY]: 'Италия',
  [LocalizationKeys.REGION_SPAIN]: 'Испания',
  [LocalizationKeys.REGION_POLAND]: 'Польша',
  [LocalizationKeys.REGION_UKRAINE]: 'Украина',
  [LocalizationKeys.REGION_NETHERLANDS]: 'Нидерланды',
  [LocalizationKeys.REGION_BELGIUM]: 'Бельгия',
  [LocalizationKeys.REGION_SWEDEN]: 'Швеция',
  [LocalizationKeys.REGION_SWITZERLAND]: 'Швейцария',
  [LocalizationKeys.REGION_AUSTRIA]: 'Австрия',
  [LocalizationKeys.REGION_DENMARK]: 'Дания',
  [LocalizationKeys.REGION_NORWAY]: 'Норвегия',
  [LocalizationKeys.REGION_FINLAND]: 'Финляндия',
  [LocalizationKeys.REGION_PORTUGAL]: 'Португалия',
  [LocalizationKeys.REGION_GREECE]: 'Греция',
  [LocalizationKeys.REGION_IRELAND]: 'Ирландия',
  [LocalizationKeys.REGION_CZECH_REPUBLIC]: 'Чехия',
  [LocalizationKeys.REGION_HUNGARY]: 'Венгрия',
  [LocalizationKeys.REGION_ROMANIA]: 'Румыния',
  [LocalizationKeys.REGION_BULGARIA]: 'Болгария',
  [LocalizationKeys.REGION_SLOVAKIA]: 'Словакия',
  [LocalizationKeys.REGION_CROATIA]: 'Хорватия',
  [LocalizationKeys.REGION_SERBIA]: 'Сербия',
  [LocalizationKeys.REGION_BOSNIA_AND_HERZEGOVINA]: 'Босния и Герцеговина',
  [LocalizationKeys.REGION_ALBANIA]: 'Албания',
  [LocalizationKeys.REGION_LITHUANIA]: 'Литва',
  [LocalizationKeys.REGION_LATVIA]: 'Латвия',
  [LocalizationKeys.REGION_ESTONIA]: 'Эстония',
  [LocalizationKeys.REGION_SLOVENIA]: 'Словения',
  [LocalizationKeys.REGION_NORTH_MACEDONIA]: 'Северная Македония',
  [LocalizationKeys.REGION_MONTENEGRO]: 'Черногория',
  [LocalizationKeys.REGION_KOSOVO]: 'Косово',
  [LocalizationKeys.REGION_MOLDOVA]: 'Молдова',
  [LocalizationKeys.REGION_BELARUS]: 'Беларусь',
  [LocalizationKeys.REGION_LUXEMBOURG]: 'Люксембург',
  [LocalizationKeys.REGION_ICELAND]: 'Исландия',
  [LocalizationKeys.REGION_ANDORRA]: 'Андорра',
  [LocalizationKeys.REGION_MONACO]: 'Монако',
  [LocalizationKeys.REGION_LIECHTENSTEIN]: 'Лихтенштейн',
  [LocalizationKeys.REGION_SAN_MARINO]: 'Сан-Марино',
  [LocalizationKeys.REGION_MALTA]: 'Мальта',
  [LocalizationKeys.REGION_CYPRUS]: 'Кипр',
  [LocalizationKeys.REGION_TURKEY]: 'Турция',
  [LocalizationKeys.REGION_ISRAEL]: 'Израиль',

  // Americas
  [LocalizationKeys.REGION_UNITED_STATES]: 'США',
  [LocalizationKeys.REGION_CANADA]: 'Канада',
  [LocalizationKeys.REGION_MEXICO]: 'Мексика',
  [LocalizationKeys.REGION_BRAZIL]: 'Бразилия',
  [LocalizationKeys.REGION_ARGENTINA]: 'Аргентина',
  [LocalizationKeys.REGION_CHILE]: 'Чили',
  [LocalizationKeys.REGION_COLOMBIA]: 'Колумбия',
  [LocalizationKeys.REGION_PERU]: 'Перу',
  [LocalizationKeys.REGION_VENEZUELA]: 'Венесуэла',
  [LocalizationKeys.REGION_ECUADOR]: 'Эквадор',
  [LocalizationKeys.REGION_BOLIVIA]: 'Боливия',
  [LocalizationKeys.REGION_PARAGUAY]: 'Парагвай',
  [LocalizationKeys.REGION_URUGUAY]: 'Уругвай',
  [LocalizationKeys.REGION_COSTA_RICA]: 'Коста-Рика',
  [LocalizationKeys.REGION_PANAMA]: 'Панама',
  [LocalizationKeys.REGION_GUATEMALA]: 'Гватемала',
  [LocalizationKeys.REGION_EL_SALVADOR]: 'Сальвадор',
  [LocalizationKeys.REGION_HONDURAS]: 'Гондурас',
  [LocalizationKeys.REGION_NICARAGUA]: 'Никарагуа',
  [LocalizationKeys.REGION_DOMINICAN_REPUBLIC]: 'Доминиканская Республика',
  [LocalizationKeys.REGION_CUBA]: 'Куба',
  [LocalizationKeys.REGION_HAITI]: 'Гаити',
  [LocalizationKeys.REGION_JAMAICA]: 'Ямайка',
  [LocalizationKeys.REGION_TRINIDAD_AND_TOBAGO]: 'Тринидад и Тобаго',
  [LocalizationKeys.REGION_BAHAMAS]: 'Багамские Острова',
  [LocalizationKeys.REGION_BARBADOS]: 'Барбадос',
  [LocalizationKeys.REGION_SAINT_LUCIA]: 'Сент-Люсия',
  [LocalizationKeys.REGION_ANTIGUA_AND_BARBUDA]: 'Антигуа и Барбуда',
  [LocalizationKeys.REGION_DOMINICA]: 'Доминика',
  [LocalizationKeys.REGION_GRENADA]: 'Гренада',
  [LocalizationKeys.REGION_SAINT_KITTS_AND_NEVIS]: 'Сент-Китс и Невис',
  [LocalizationKeys.REGION_SAINT_VINCENT_AND_THE_GRENADINES]: 'Сент-Винсент и Гренадины',
  [LocalizationKeys.REGION_BELIZE]: 'Белиз',
  [LocalizationKeys.REGION_GUYANA]: 'Гайана',
  [LocalizationKeys.REGION_SURINAME]: 'Суринам',

  // Asia
  [LocalizationKeys.REGION_CHINA]: 'Китай',
  [LocalizationKeys.REGION_JAPAN]: 'Япония',
  [LocalizationKeys.REGION_SOUTH_KOREA]: 'Южная Корея',
  [LocalizationKeys.REGION_INDIA]: 'Индия',
  [LocalizationKeys.REGION_INDONESIA]: 'Индонезия',
  [LocalizationKeys.REGION_PHILIPPINES]: 'Филиппины',
  [LocalizationKeys.REGION_VIETNAM]: 'Вьетнам',
  [LocalizationKeys.REGION_THAILAND]: 'Таиланд',
  [LocalizationKeys.REGION_MALAYSIA]: 'Малайзия',
  [LocalizationKeys.REGION_SINGAPORE]: 'Сингапур',
  [LocalizationKeys.REGION_PAKISTAN]: 'Пакистан',
  [LocalizationKeys.REGION_BANGLADESH]: 'Бангладеш',
  [LocalizationKeys.REGION_SRI_LANKA]: 'Шри-Ланка',
  [LocalizationKeys.REGION_NEPAL]: 'Непал',
  [LocalizationKeys.REGION_MYANMAR]: 'Мьянма',
  [LocalizationKeys.REGION_CAMBODIA]: 'Камбоджа',
  [LocalizationKeys.REGION_LAOS]: 'Лаос',
  [LocalizationKeys.REGION_BRUNEI]: 'Бруней',
  [LocalizationKeys.REGION_MONGOLIA]: 'Монголия',
  [LocalizationKeys.REGION_NORTH_KOREA]: 'Северная Корея',
  [LocalizationKeys.REGION_TAIWAN]: 'Тайвань',
  [LocalizationKeys.REGION_HONG_KONG]: 'Гонконг',
  [LocalizationKeys.REGION_MACAU]: 'Макао',
  [LocalizationKeys.REGION_KAZAKHSTAN]: 'Казахстан',
  [LocalizationKeys.REGION_UZBEKISTAN]: 'Узбекистан',
  [LocalizationKeys.REGION_TURKMENISTAN]: 'Туркменистан',
  [LocalizationKeys.REGION_KYRGYZSTAN]: 'Киргизия',
  [LocalizationKeys.REGION_TAJIKISTAN]: 'Таджикистан',
  [LocalizationKeys.REGION_AFGHANISTAN]: 'Афганистан',
  [LocalizationKeys.REGION_MALDIVES]: 'Мальдивы',
  [LocalizationKeys.REGION_BHUTAN]: 'Бутан',
  [LocalizationKeys.REGION_TIMOR_LESTE]: 'Восточный Тимор',

  // Middle East
  [LocalizationKeys.REGION_UNITED_ARAB_EMIRATES]: 'ОАЭ',
  [LocalizationKeys.REGION_SAUDI_ARABIA]: 'Саудовская Аравия',
  [LocalizationKeys.REGION_IRAN]: 'Иран',
  [LocalizationKeys.REGION_IRAQ]: 'Ирак',
  [LocalizationKeys.REGION_SYRIA]: 'Сирия',
  [LocalizationKeys.REGION_LEBANON]: 'Ливан',
  [LocalizationKeys.REGION_JORDAN]: 'Иордания',
  [LocalizationKeys.REGION_YEMEN]: 'Йемен',
  [LocalizationKeys.REGION_OMAN]: 'Оман',
  [LocalizationKeys.REGION_QATAR]: 'Катар',
  [LocalizationKeys.REGION_KUWAIT]: 'Кувейт',
  [LocalizationKeys.REGION_BAHRAIN]: 'Бахрейн',
  [LocalizationKeys.REGION_PALESTINE]: 'Палестина',

  // Africa
  [LocalizationKeys.REGION_EGYPT]: 'Египет',
  [LocalizationKeys.REGION_NIGERIA]: 'Нигерия',
  [LocalizationKeys.REGION_SOUTH_AFRICA]: 'ЮАР',
  [LocalizationKeys.REGION_KENYA]: 'Кения',
  [LocalizationKeys.REGION_GHANA]: 'Гана',
  [LocalizationKeys.REGION_ALGERIA]: 'Алжир',
  [LocalizationKeys.REGION_MOROCCO]: 'Марокко',
  [LocalizationKeys.REGION_ETHIOPIA]: 'Эфиопия',
  [LocalizationKeys.REGION_TANZANIA]: 'Танзания',
  [LocalizationKeys.REGION_UGANDA]: 'Уганда',
  [LocalizationKeys.REGION_SUDAN]: 'Судан',
  [LocalizationKeys.REGION_TUNISIA]: 'Тунис',
  [LocalizationKeys.REGION_LIBYA]: 'Ливия',
  [LocalizationKeys.REGION_ANGOLA]: 'Ангола',
  [LocalizationKeys.REGION_CAMEROON]: 'Камерун',
  [LocalizationKeys.REGION_IVORY_COAST]: 'Кот-д\'Ивуар',
  [LocalizationKeys.REGION_MADAGASCAR]: 'Мадагаскар',
  [LocalizationKeys.REGION_SENEGAL]: 'Сенегал',
  [LocalizationKeys.REGION_ZIMBABWE]: 'Зимбабве',
  [LocalizationKeys.REGION_MOZAMBIQUE]: 'Мозамбик',
  [LocalizationKeys.REGION_ZAMBIA]: 'Замбия',
  [LocalizationKeys.REGION_MALAWI]: 'Малави',
  [LocalizationKeys.REGION_BURKINA_FASO]: 'Буркина-Фасо',
  [LocalizationKeys.REGION_MALI]: 'Мали',
  [LocalizationKeys.REGION_NIGER]: 'Нигер',
  [LocalizationKeys.REGION_CHAD]: 'Чад',
  [LocalizationKeys.REGION_SOMALIA]: 'Сомали',
  [LocalizationKeys.REGION_ERITREA]: 'Эритрея',
  [LocalizationKeys.REGION_RWANDA]: 'Руанда',
  [LocalizationKeys.REGION_BURUNDI]: 'Бурунди',
  [LocalizationKeys.REGION_BENIN]: 'Бенин',
  [LocalizationKeys.REGION_TOGO]: 'Того',
  [LocalizationKeys.REGION_GUINEA]: 'Гвинея',
  [LocalizationKeys.REGION_SIERRA_LEONE]: 'Сьерра-Леоне',
  [LocalizationKeys.REGION_LIBERIA]: 'Либерия',
  [LocalizationKeys.REGION_CENTRAL_AFRICAN_REPUBLIC]: 'ЦАР',
  [LocalizationKeys.REGION_CONGO_DEMOCRATIC_REPUBLIC]: 'ДР Конго',
  [LocalizationKeys.REGION_CONGO]: 'Республика Конго',
  [LocalizationKeys.REGION_GABON]: 'Габон',
  [LocalizationKeys.REGION_EQUATORIAL_GUINEA]: 'Экваториальная Гвинея',
  [LocalizationKeys.REGION_SAO_TOME_AND_PRINCIPE]: 'Сан-Томе и Принсипи',
  [LocalizationKeys.REGION_MAURITIUS]: 'Маврикий',
  [LocalizationKeys.REGION_SEYCHELLES]: 'Сейшельские Острова',
  [LocalizationKeys.REGION_COMOROS]: 'Коморы',
  [LocalizationKeys.REGION_CAPE_VERDE]: 'Кабо-Верде',
  [LocalizationKeys.REGION_ESWATINI]: 'Эсватини',
  [LocalizationKeys.REGION_LESOTHO]: 'Лесото',
  [LocalizationKeys.REGION_BOTSWANA]: 'Ботсвана',
  [LocalizationKeys.REGION_NAMIBIA]: 'Намибия',
  [LocalizationKeys.REGION_SOUTH_SUDAN]: 'Южный Судан',
  [LocalizationKeys.REGION_DJIBOUTI]: 'Джибути',
  [LocalizationKeys.REGION_MAURITANIA]: 'Мавритания',
  [LocalizationKeys.REGION_GAMBIA]: 'Гамбия',
  [LocalizationKeys.REGION_GUINEA_BISSAU]: 'Гвинея-Бисау',

  // Oceania
  [LocalizationKeys.REGION_AUSTRALIA]: 'Австралия',
  [LocalizationKeys.REGION_NEW_ZEALAND]: 'Новая Зеландия',
  [LocalizationKeys.REGION_PAPUA_NEW_GUINEA]: 'Папуа — Новая Гвинея',
  [LocalizationKeys.REGION_FIJI]: 'Фиджи',
  [LocalizationKeys.REGION_SOLOMON_ISLANDS]: 'Соломоновы Острова',
  [LocalizationKeys.REGION_VANUATU]: 'Вануату',
  [LocalizationKeys.REGION_SAMOA]: 'Самоа',
  [LocalizationKeys.REGION_TONGA]: 'Тонга',
  [LocalizationKeys.REGION_KIRIBATI]: 'Кирибати',
  [LocalizationKeys.REGION_MICRONESIA]: 'Микронезия',
  [LocalizationKeys.REGION_PALAU]: 'Палау',
  [LocalizationKeys.REGION_MARSHALL_ISLANDS]: 'Маршалловы Острова',
  [LocalizationKeys.REGION_NAURU]: 'Науру',
  [LocalizationKeys.REGION_TUVALU]: 'Тувалу',
} as const satisfies PartialTranslations
